module.exports = __webpack_public_path__ + "img/backhoe_stopped.40fec886.svg";